// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--3mBiF";
export var row = "Footer-module--row--3pcsI";
export var spaceBetween = "Footer-module--spaceBetween--1QOtq";
export var link = "Footer-module--link--2LsB4";
export var fadeIn = "Footer-module--fadeIn--2GUmJ";
export var slideIn = "Footer-module--slideIn--1Dex1";
export var bgGradient = "Footer-module--bgGradient--1HS5k";
export var borderColorStep = "Footer-module--borderColorStep--1ZIa_";